import { ServiceTypeEnum } from "../../pages/model-manager/variables/modelManager";

export const nameParser = {
  node(id: string): string {
    return id.split("#N#")[1] ?? id;
  },

  device(id: string): string {
    return id.split("DE#")[1] ?? id;
  },

  service(id: string): string {
    return id.split("S#")[1]?.split("_")[1] ?? id;
  },

  serviceWithAbbreviation(id: string): string {
    const serviceName = id.split("S#")[1];

    const deviceName = id.split("_")[1];

    const fullServiceName = modelNameParser(serviceName);

    return `${fullServiceName}: ${deviceName}`;
  },
};

export const modelNameParser = (id: string): ServiceTypeEnum => {
  let modelName: ServiceTypeEnum = ServiceTypeEnum.LEAK;

  switch (true) {
    case id?.includes("gl_"):
      modelName = ServiceTypeEnum.LEAK;
      break;

    case id?.includes("ll_"):
      modelName = ServiceTypeEnum.LIQUID_LEAK;
      break;

    case id?.includes("hh_"):
      modelName = ServiceTypeEnum.HARD_HAT;
      break;

    case id?.includes("tl_"):
      modelName = ServiceTypeEnum.TANK_LEVEL;
      break;

    case id?.includes("fs_"):
      modelName = ServiceTypeEnum.FIRE_SMOKE;
      break;

    case id?.includes("gg_"):
      modelName = ServiceTypeEnum.GATE_GUARD;
      break;

    default:
      break;
  }

  return modelName;
};
